module.exports = __webpack_public_path__ + "static/thumbnail-48b4384003d8dfc6b2745da8b4d0aff0.png";